// extracted by mini-css-extract-plugin
export default {"avatar-name-wrapper":"AvatarName_avatar-name-wrapper_o78iW","avatar-name-btn":"AvatarName_avatar-name-btn_CkYky","nickname-input":"AvatarName_nickname-input_scpIw"};